import { AlmacenAxios } from '@/services/Axios';

const resource = '/settings';

export default {
  async getPriceSettings() {
    return AlmacenAxios.get(`${resource}/pricing`);
  },
};
